import {DEFAULT_TERRAIN_SETTINGS,normalizeTerrainSettings,sampleTerrainGradient} from '../config/terrainSettings.js';
import {SLOPE_STOPS,SLOPE_INTERVAL,sampleSlopeColor} from '../config/slopeAngle.js';
export const ELEVATION_COLORS=DEFAULT_TERRAIN_SETTINGS.stops.map(stop=>sampleTerrainGradient(DEFAULT_TERRAIN_SETTINGS.stops,stop.position));
// Adjacent tiles share one scale. Keep only a handful of serialized palettes so
// panning does not repeatedly interpolate and serialize the same 32-color rule.
const colorRuleCache=new Map();
function colorRule(range){
 const key=JSON.stringify([range.minMeters,range.maxMeters,range.gradientStops??DEFAULT_TERRAIN_SETTINGS.stops]);
 if(colorRuleCache.has(key))return colorRuleCache.get(key);
 const rule=JSON.stringify(elevationRenderingRule(range));
 if(colorRuleCache.size>=16)colorRuleCache.delete(colorRuleCache.keys().next().value);
 colorRuleCache.set(key,rule);return rule;
}
export function elevationRenderingRule(range){
 if(!Number.isFinite(range.minMeters)||!Number.isFinite(range.maxMeters)||range.maxMeters<=range.minMeters)throw Error('Invalid elevation scale');
 const {stops}=normalizeTerrainSettings({stops:range.gradientStops??DEFAULT_TERRAIN_SETTINGS.stops});
 const inputs=[],outputs=[],colors=[];
 for(let i=0;i<32;i++){
  colors.push([i,...sampleTerrainGradient(stops,i/31*100)]);
  inputs.push(i===0?-12000:Number((range.minMeters+(range.maxMeters-range.minMeters)*i/32).toFixed(3)),i===31?12000:Number((range.minMeters+(range.maxMeters-range.minMeters)*(i+1)/32).toFixed(3)));outputs.push(i);
 }
 return {rasterFunction:'Colormap',rasterFunctionArguments:{Colormap:colors,Raster:{rasterFunction:'Remap',rasterFunctionArguments:{InputRanges:inputs,OutputValues:outputs,Raster:'$$',AllowUnmatched:false},outputPixelType:'U8'}},outputPixelType:'U8'};
}
export function terrainTileUrl(coords,contours,range){
 const half=20037508.342789244,size=2*half/2**coords.z;
 const west=-half+coords.x*size,north=half-coords.y*size;
 const params=new URLSearchParams({f:'image',bbox:[west,north-size,west+size,north].join(','),bboxSR:'3857',imageSR:'3857',size:'256,256',format:'png32',interpolation:'RSP_BilinearInterpolation',renderingRule:range?colorRule(range):JSON.stringify({rasterFunction:contours?'Preset 10ft Contour Interval':'Hillshade Multidirectional'})});
 return 'https://elevation.nationalmap.gov/arcgis/rest/services/3DEPElevation/ImageServer/exportImage?'+params;
}

export function slopeRenderingRule(){
 const inputs=[],outputs=[],colors=[],first=SLOPE_STOPS[0].degrees,last=SLOPE_STOPS.at(-1).degrees;
 for(let degrees=first;degrees<=last;degrees+=SLOPE_INTERVAL){
  const index=colors.length;
  inputs.push(degrees,degrees===last?90.000001:degrees+SLOPE_INTERVAL);
  outputs.push(index);colors.push([index,...sampleSlopeColor(degrees)]);
 }
 // Floating-point output is essential: the service otherwise rounds degrees.
 // Remap unmatched pixels to NoData so low angles and missing data stay clear.
 return {rasterFunction:'Colormap',rasterFunctionArguments:{Colormap:colors,Raster:{rasterFunction:'Remap',rasterFunctionArguments:{Raster:{rasterFunction:'Slope Degrees',outputPixelType:'F32'},InputRanges:inputs,OutputValues:outputs,AllowUnmatched:false},outputPixelType:'U8'}},outputPixelType:'U8'};
}
const slopeRule=JSON.stringify(slopeRenderingRule());
export function slopeTileUrl(coords){
 // Preserve the existing elevation/relief/contour URLs and cache identities.
 const url=new URL(terrainTileUrl(coords,false));
 url.searchParams.set('renderingRule',slopeRule);
 // Do not interpolate between already classified colors or across NoData.
 url.searchParams.set('interpolation','RSP_NearestNeighbor');
 return url.href;
}

